<template>
  <div id="app">
    <v-app>
      <v-expand-transition>
        <v-toolbar
          v-show="loggedIn"
          class="main_app_toolbar"
          :class="{ beta: !isProduction }"
          flat
          color="#0d47a1"
          dark
          fixed
          dense
          app
        >
          <v-spacer/>
          <v-toolbar-title
            v-if="getDomainInfo.app_name && getDomainInfo.app_name == 'CaseLocker'"
            style="font-weight:300;display: flex;justify-content: center;align-items: center;"
          >
            <img
              src="/assets/caselocker.png"
              style="height:40px;margin-right:10px;"
            />
            {{isProduction ? 'Case' : 'Beta'}}<span style="font-weight:700;">Locker</span>
            <v-icon
              v-if="iconUrl !== null"
              small
              style="padding-bottom:1px;vertical-align:middle"
            >
              chevron_right
            </v-icon>
            <img
              :src="iconUrl"
              style="max-width:28px;vertical-align:middle;"
              alt="Firm Logo"
            />
          </v-toolbar-title>
          <v-toolbar-title
            v-else-if="getDomainInfo.app_name"
            style="font-weight:500;"
          >
            <img
              :src="iconUrl"
              style="max-width:28px;vertical-align:middle;margin-right: 10px;"
              alt="Firm Logo"
            />
            <span
              style="font-size: 16px;"
            >
              {{ getDomainInfo.app_name }}
            </span>
          </v-toolbar-title>
          <v-spacer/>
          <v-spacer/>
          <v-toolbar-items>
            <v-btn
              flat
              :to="{ name: 'AppHome' }"
              exact
            >
              Home
            </v-btn>
            <v-menu
              v-if="checkPermission('templates', PERMISSIONS.CAN_CREATE)"
              offset-y
              open-on-hover
            >
              <v-btn flat
                slot="activator"
                :to="{ name: 'FormTemplateList' }">
                  Templates
              </v-btn>
              <v-list dense>
                <v-list-tile
                  :to="{ name: 'FormTemplateList' }">
                  <v-list-tile-title>
                    <v-icon small
                      left>search</v-icon>
                      Search Templates
                  </v-list-tile-title>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile
                  :to="{ name: 'FormTemplate' }">
                  <v-list-tile-title>
                    <v-icon small
                      left>insert_drive_file</v-icon>
                      New Form Template
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <v-menu offset-y
              open-on-hover>
              <v-btn flat
                slot="activator"
                :to="{ name: 'ContactList' }">
                  Contacts
              </v-btn>
              <v-list dense>
                <v-list-tile
                  :to="{ name: 'ContactList' }">
                  <v-list-tile-title>
                    <v-icon small
                      left>search</v-icon>
                      Search Contacts
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  v-if="checkPermission('contacts_files', PERMISSIONS.CAN_VIEW)"
                  :to="{ name: 'ContactFilesList' }">
                  <v-list-tile-title>
                    <v-icon small
                      left>file_copy</v-icon>
                      Search Files
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  v-if="checkPermission('contacts_messages', PERMISSIONS.CAN_VIEW)"
                  :to="{ name: 'ContactMessageSearch' }">
                  <v-list-tile-title>
                    <v-icon small
                      left>search</v-icon>
                      Search Messages
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  v-if="checkPermission('contacts_messages', PERMISSIONS.CAN_BULK)"
                  :to="{ name: 'ContactMassMessaging' }">
                  <v-list-tile-title>
                    <v-icon small
                      left>email</v-icon>
                      Bulk Messaging
                  </v-list-tile-title>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile
                  v-if="checkPermission('contacts', PERMISSIONS.CAN_CREATE)"
                  @click="newContact = true"
                >
                  <v-list-tile-title>
                    <v-icon small
                      left>face</v-icon>
                      New Contact
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  v-if="checkPermission('contacts', PERMISSIONS.CAN_BULK)"
                  :to="{ name: 'ContactBulkOps' }">
                  <v-list-tile-title>
                    <v-icon small
                      left>mdi-script-outline</v-icon>
                      Bulk Operations
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <v-btn
              flat
              :to="{ name: 'CaseTypeList' }"
            >
              Cases
            </v-btn>
            <v-menu offset-y
              open-on-hover>
              <v-btn flat
                slot="activator"
                :to="{ name: 'UserFormList' }">
                  Forms
              </v-btn>
              <v-list dense>
                <v-list-tile
                  :to="{ name: 'UserFormList' }">
                  <v-list-tile-title>
                    <v-icon small
                      left>search</v-icon>
                      Search Forms
                  </v-list-tile-title>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile
                  v-if="checkPermission('userform', PERMISSIONS.CAN_BULK)"
                  :to="{ name: 'UserFormBulkOps' }">
                  <v-list-tile-title>
                    <v-icon small
                      left>mdi-script-outline</v-icon>
                      Bulk Operations
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <v-btn
              flat
              :to="{ name: 'ReportList' }"
              exact
            >
              Reports
            </v-btn>
          </v-toolbar-items>
          <v-spacer/>
          <v-toolbar-items>
            <Notifications
              v-if="loggedIn"
              :banner="banner_hide && banner ? banner : null"
            />
            <v-menu
              offset-y
              left
              open-on-hover
            >
              <v-btn flat
                slot="activator"
                style="min-width:0px;"
              >
                <v-icon>
                  settings
                </v-icon>
              </v-btn>
              <v-list dense>
                <v-subheader>
                  {{ user }}
                </v-subheader>
                <v-divider/>
                <v-list-tile
                  v-if="isAdmin"
                  :to="{ name: 'OrgBranding' }">
                  <v-list-tile-title>
                    <v-icon small
                      left>domain</v-icon>
                    My Organization
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  v-if="isSuper"
                  :to="{ name: 'SuperUserOrgs' }">
                  <v-list-tile-title>
                    <v-icon small
                      left>build</v-icon>
                    Organization Manager
                  </v-list-tile-title>
                </v-list-tile>
                <v-divider/>
                <v-list-tile
                  :to="{ name: 'UserCurrent' }">
                  <v-list-tile-title>
                    <v-icon small
                      left>person_pin_circle</v-icon>
                    My Settings
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  color="red"
                  @click="logOut">
                  <v-list-tile-title>
                    <v-icon small
                      left>exit_to_app</v-icon>
                    Log Out
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar-items>
        </v-toolbar>
      </v-expand-transition>
      <v-content>
        <v-expand-transition>
          <div
            v-if="banner && !banner_hide"
            :class="banner.type"
            style="color: white;padding: 10px 25px 10px 25px;"
          >
            <div
              style="margin:auto;max-width: 1400px;"
            >
              <div
                v-if="banner.icon"
                style="display:inline-block;padding: 0 20px 0 0;"
              >
                <v-icon
                  dark
                  size="32"
                >
                  {{ banner.icon }}
                </v-icon>
              </div>
              <div
                style="display:inline-block;"
              >
                <b>{{ 'title' in banner ? banner.title : "Service Alert" }}</b><br />
                {{ 'message' in banner ? banner.message : "A service alert is active, and you may experience degraded performance. We're working to resolve the issues as soon as possible." }}
              </div>
              <div
                style="display:inline;float:right;"
              >
                <v-btn
                  v-if="'action_button' in banner"
                  small
                  outline
                  dark
                  :href="banner.action_button.link"
                >
                  {{ banner.action_button.text }}
                </v-btn>
                <v-btn
                  v-if="banner.dismissible"
                  small
                  icon
                  dark
                  @click="banner_hide = true"
                >
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
              </div>
              <div
                style="clear:both;"
              ></div>
            </div>
          </div>
        </v-expand-transition>
        <div
          v-if="$route.meta.fullWidth"
        >
          <router-view
            :logo="logoUrl"
            :icon="iconUrl"
            :version="version"
            :settings="getDomainInfo"
            @showPrivacyPolicy="showPrivacyPolicy = true"
          ></router-view>
        </div>
        <v-container
          v-else
          style="max-width:1400px;height:100%"
        >
          <router-view
            :logo="logoUrl"
            :icon="iconUrl"
            :version="version"
            :settings="getDomainInfo"
            @showPrivacyPolicy="showPrivacyPolicy = true"
          ></router-view>
        </v-container>
      </v-content>
      <v-expand-transition>
        <v-footer class="pa-3">
          <small class="legalFoot"></small>
          <small
            style="margin-left: 10px;"
          >
            <a
              @click="showPrivacyPolicy = true"
            >
              Privacy Policy
            </a>
          </small>
          <v-spacer/>
          <div>v{{version}} | &copy; {{ new Date().getFullYear() }}</div>
        </v-footer>
      </v-expand-transition>
      <ErrorDialog
        :error="error"
        />
    </v-app>
    <TimeOutDialog
      v-if="showTimeOut"
      @logout="logOut()"
      v-on:refresh="showTimeOut = false; refreshAction()"
      />

    <NewVersionDialog
      v-if="showForceRefresh"
      />

    <MaintDialog
      v-if="maintdialogVisible"
      />

    <ContactDialog
      v-if="newContact"
      @input="newContact = false;$router.push({ name: 'Contact', params: { id: arguments[0].id } })"
      @cancel="newContact = false"
    />

    <RedirectDialog
      v-if="showRedirectDialog"
    />
    
    <v-snackbar
      :value="showRecommendRefresh"
      bottom
      :timeout="0"
      vertical
    >
      There is a new version of {{ app_name }} available. It is recommended you refresh the page.
      <v-btn
        flat
        @click="$router.go()"
      >
        Refresh
      </v-btn>
    </v-snackbar>

    <v-snackbar
      :value="offline"
      bottom right
      color="red"
      dark
      :timeout="0"
    >
      It appears you are offline. Check your connection.
    </v-snackbar>

    <v-dialog
      v-model="showPrivacyPolicy"
      fullscreen
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card>
        <v-card-text>
          <div class="forced-content-spacer" style="height: 20vh;width: 100%;" />
          <PrivacyPolicy />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="showPrivacyPolicy = false"
            color="red"
            outline
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showSoftRedirectDialog"
      width="600"
    >
      <v-card
        style="background: rgb(30, 136, 229);color:white;"
      >
        <v-card-text>
          <v-layout wrap>
            <v-flex
              md2
            >
              <v-icon
                dark
                size="64"
              >
                mdi-dolly
              </v-icon>
            </v-flex>
            <v-flex
              md10
            >
              <div
                style="font-size: 18px;"
              >
                {{ app_name }} is moving!
              </div>
              <div>
                {{ app_name }} is now available under caselocker.com. Nothing is changing but the domain name, and all existing links will continue to work.<br /><br />
                <small>
                  You can ignore this for now, but all users will be redirected automatically starting April 1st. Contact login &amp; message links have been updated to {{ getDomainInfo.subdomain }}.caselocker.com
                </small>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions
          style="background: rgb(224, 224, 224);"
        >
          <v-spacer />
          <v-btn
            flat
            small
            @click="dismissSoftRedirect()"
          >
            Not right now
          </v-btn>
          <v-btn
            color="primary"
            @click="redirectToNewDomain()"
          >
            Go to {{ getDomainInfo.subdomain }}.caselocker.com
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Notifications from '@/components/admin/Notifications.vue'
import ErrorDialog from '@/components/global/ErrorDialog'
import ContactDialog from '@/components/admin/contacts/ContactDialog'
import TimeOutDialog from '@/components/global/TimeOutDialog'
import NewVersionDialog from '@/components/global/NewVersionDialog'
import MaintDialog from '@/components/global/MaintDialog'
import PrivacyPolicy from '@/components/global/PrivacyPolicy'
import RedirectDialog from '@/components/global/RedirectDialog'
import errorHandling from '@/components/global/errorhandling.js'
import appMixin from '@/components/global/appmixin.js'
import { mapGetters, mapMutations } from 'vuex'
import api from '@/api'

export default {
  name: 'App',
  components: {
    ErrorDialog,
    TimeOutDialog,
    ContactDialog,
    NewVersionDialog,
    MaintDialog,
    Notifications,
    PrivacyPolicy,
    RedirectDialog
  },
  mixins: [
    errorHandling,
    appMixin
  ],
  data () {
    return {
      newContact: false,
      showPrivacyPolicy: false,
      banner: null,
      banner_hide: false,
      showRedirectDialog: false,
      showSoftRedirectDialog: false,
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isSuper',
      'isAdmin',
      'loggedIn',
      'getDomainInfo',
      'token'
    ])
  },
  watch: {
    loggedIn() {
      this.startTracker(this.userInfo)
      this.checkOpenRedirectDialog()
    }
  },
  beforeCreate () {
    api.auth.organization.getInfo()
      .then((info) => {
        this.setDomainInfo(info)
        this.startTracker(this.userInfo)
        if ('banner' in info) {
          this.banner = info['banner']
        }
      })
  },
  created () {
    let isLogin = this.$route.path.includes("login")
    if (!isLogin && this.$route.query.clredirect !== undefined)
      this.showRedirectDialog = true
    if (this.userInfo.username.startsWith('client-')){
      this.$router.push({path: '/home'})
      this.$router.go()
    }
    this.checkOpenRedirectDialog()
  },
  methods: {
    ...mapMutations('auth', [
      'setDomainInfo',
    ]),
    dismissSoftRedirect() {
      this.showSoftRedirectDialog = false
      localStorage.setItem("ignore-redirect", "1")
    },
    redirectToNewDomain() {
      if (this.token)
        window.location.replace(`https://${this.getDomainInfo.subdomain}.caselocker.com/admin/login?token=${this.token}`)
      else
        window.location.replace(`https://${this.getDomainInfo.subdomain}.caselocker.com/admin/login/`)
    },
    checkOpenRedirectDialog () {
      if (this.userInfo.username)
        if (this.isLegacyDomain()) {
          var ignoreRedirect = localStorage.getItem("ignore-redirect")
          if (!ignoreRedirect) {
            this.showSoftRedirectDialog = true
          }
        }
    }
  }
}
</script>

<style>

.beta {
  background: repeating-linear-gradient(
    45deg,
    rgba(0,0,0,0),
    rgba(0,0,0,0) 10px,
    black 10px,
    black 20px
  ) !important;
}

.placeholder-chip {
  background: rgba(0,0,0,0.1);
  padding: 3px 7px 3px 3px;
  margin-left: 5px;
  margin-right: 5px;
  border-radius: 10px;
  font-weight: bold;
  outline: 2px solid rgba(0,0,0,0.2);
  outline-offset: -2px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
}

.placeholder-chip span {
  background: white;
  padding: 1px 2px 1px 4px;
  margin-right: 5px;
  border-radius: 10px 0 0 10px;
}

.autocomplete-no-data {
  padding: 5px 10px;
}

</style>
